import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Button } from '@econ/ui-elements';
import Layout from '../../../shared/components/Layout';
import error from '../error.png';
import '../style.css';

function NotFound({ history }: RouteComponentProps) {
    return (
        <Layout>
            <Layout.Content>
                <div id="error">
                    <img src={error} alt="An error occurred" />

                    <h1>Page Not Found</h1>
                    <p>Unfortunately we couldn't find the page you're looking for.</p>
                    <Button onClick={() => history.goBack()} type="primary">
                        Go back
                    </Button>
                </div>
            </Layout.Content>
        </Layout>
    );
}

export default withRouter(NotFound);
